<template>
  <div id="nstore-page">
    <topNav :tit="'找门店'"></topNav>
    <SearchBar :cityCode="queryCondition.cityId" @listenChild="receiveChildData"></SearchBar>
    <div class="near-store-container">
      <div id="near-store">
        <ul>
          <li class="near-store-item" v-for="(item,index) in nearStore" @click="prompt(item.storeType)">
          <span class="ns-kli" v-if="item.dist">{{item.dist}}KM</span>
          <div class="ns-img" :class="[{'default-logo': !item.picUrl}, 'store-type-' + item.storeType]">
            <a :href="item.jumpUrl">
              <img v-if="item.picUrl" :src="item.picUrl | urlProtocol" alt="">
            </a>
          </div>
          <div class="ns-detail">
            <a :href="item.jumpUrl">
              <h2>{{item.storeName}}</h2>
              <div class="ns-tag">
                <span v-for="tag in item.tags">{{tag}}</span>
              </div>
            </a>
            <div class="ns-act-container" v-if="item.activity && item.activity.length > 0" :class="{'act-more': item.isActMore}">
              <div class="ns-act-item" v-for="activity in item.activity">
                <span class="act-tag">促销</span>
                <span>{{activity.title}}</span>
                <span class="act-arrow" v-if="item.activity.length > 1" @click="moreAct(item.storeCode)"></span>
              </div>
            </div>
            <!--导购小于4个时不展示，多余4个时只展示4个-->
            <div class="ns-guide" v-if="item.windowList && item.windowList.length > 0">
              <div v-for="guide in item.windowList" :class="guide.type">
                <div class="ns-guide-pic">
                  <a :href="guide.link">
                    <img :src="guide.img | urlProtocol" alt="">
                  </a>
                </div>
                <span>{{guide.name}}</span>
              </div>
            </div>
          </div>
        </li>
        </ul>
      </div>
      <div class="sn-loading-type" v-if="nearStore.length > 0">
        <span class="sn-pull-loading hide">上拉精彩无限</span>
        <div class="sn-end-loading hide"><span>没有更多了</span></div>
      </div>
      <div class="loadmore" data-loaded=""></div>
    </div>
    <NoonInfo v-if="NoonInfo" :msg="'没有找到你想要的~'"></NoonInfo>
    <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-附近门店页">
  </div>
</template>
<script>
  //导入模块
  import CONF from '@/app.conf.json';
  import Server from '../services/Entrance';
  import {Util} from '../commons/util'

  import topNav from '@/components/commons/_topNav'
  import SearchBar from '@/components/commons/SearchStoreBar'
  import NoonInfo from '@/components/commons/NoonInfo'

  import _ from 'lodash';

  export default {
    name: 'SearchStore',
    data () {
      return {
        nearStore: [],
        totalPage: 100,
        loadable: false,
        queryCondition: {
          cityId: '',
          districtId: '',
          queryVal: '',
          storeType: '',
          cbdId: '',
          longitude: '',
          latitude: '',
          queryType: 3,
          top: false,
          pageNumber: 1,
          isLastPage: 0
        },
        NoonInfo: false
      }
    },
    // 生命周期钩子
    mounted () {
      window.scrollTo(0,0);
      document.title="附近门店";

      let _this = this,
        urlParams = _this.$route.params;

      _this.queryCondition.cityId = urlParams.cityCode;

      _this.queryCondition.pageNumber = 1;

      // 定位
      _this.geoFn().then(data => {
        _this.getNearStore();

        setTimeout(() => {

          // lazyload
          let $loadMore = $(".loadmore"),
          $pullLoading = $(".sn-pull-loading"),
          $snEndLoading = $(".sn-end-loading");

          console.log('isLastPage',_this.queryCondition.isLastPage)
          if(_this.queryCondition.isLastPage === 1){
            $loadMore.attr("data-loaded", "done");
            $pullLoading.hide();
            $snEndLoading.show();
            return
          }

          $loadMore.lazyload(function (el) {

          if (!_this.loadable) {

            return;
          }

          _this.loadable = false;

          if (_this.queryCondition.isLastPage === 1) {

//          	alert('mounted')

            $pullLoading.hide();
            $snEndLoading.show();
            el.attr("data-loaded", "done");
            return;
          }

          _this.queryCondition.pageNumber++;

          Server.home.queryHomeNearStore(_this.queryCondition).then(data => {
            console.log(data)
            _this.queryCondition.isLastPage = data.isLastPage;

            _this.nearStore = _this.nearStore.concat(_this.dealNearStoreData(data.datas));
          _this.loadable = true;

        });
          $pullLoading.show();
        });
        }, 200);
      });
    },
    components: {
      topNav,
      SearchBar,
      NoonInfo
    },
    watch: {

    },
    /*beforeRouteEnter(to, from, next) {
    },*/
    methods: {
      receiveChildData(e) {
        $(".loadmore").attr('data-loaded','')
        $(".sn-pull-loading").show();
        $(".sn-end-loading").hide();

        let key = _.keys(e)[0],
          _this = this;

        if (key === 'cbdId' && !e[key]) {
          // 如果选择的是是附近
          _this.queryCondition.queryType = 4;
        }

        if (key === 'cbdId') {
          _this.queryCondition.districtId = '';
        }
        if (key === 'districtId') {
          _this.queryCondition.cbdId = '';
        }

        _this.queryCondition[key] = e[key];
        _this.queryCondition.pageNumber = 1;

        _this.getNearStore();
      },
      getNearStore() {
        let _this = this;
        Server.home.queryHomeNearStore(_this.queryCondition).then(data => {
          console.log(data)
        	if(!data.datas.length){
            _this.nearStore = []
        		_this.NoonInfo = true;
          }else {
            _this.NoonInfo = false;
            _this.nearStore = _this.dealNearStoreData(data.datas);
            _this.queryCondition.isLastPage = data.isLastPage;
            setTimeout(() =>{
              if(_this.queryCondition.isLastPage === 1){

                $(".loadmore").attr('data-loaded','done')
                $(".sn-pull-loading").hide();
                $(".sn-end-loading").show();
              }
            },50)

            _this.loadable = true;
          }
        });
      },
      dealNearStoreData(data) {
        console.log(data)
        let _this = this;
        _.forEach(data, item => {

          // 处理页面跳转的url
          let storeType = item.storeType * 1,
            linkUrl = '';

          if (storeType === 1 || storeType === 5 || storeType === 8 || storeType === 9 || storeType === 13 || storeType === 14) {
            linkUrl = `${CONF.otherPage.electricShop}${storeType}/${item.storeCode}/${_this.queryCondition.cityId}`;
          } else if (storeType === 2) {
            linkUrl = `${CONF.otherPage.station}${_this.queryCondition.cityId}/${item.storeCode}`;
          } else if (storeType === 3) {
            linkUrl = `${CONF.otherPage.homeNavToType3}?storeCode=${item.storeCode}&lng=${_this.queryCondition.longitude}&lat=${_this.queryCondition.latitude}`;
          } else if (storeType === 4) {
            linkUrl = `${CONF.otherPage.homeNavToType4}?storeCode=${item.storeCode}&lng=${_this.queryCondition.longitude}&lat=${_this.queryCondition.latitude}`;
          } else if(storeType === 10){
            linkUrl = `${CONF.otherPage.homeNavToType10}${item.storeCode}`;
          } else if(storeType === 12 || storeType === 15){
            linkUrl = 'javascript:void(0);'
          } else if(storeType === 6 || storeType === 7){
            if(item.jumpUrl){
              linkUrl = item.jumpUrl;

            }else {
              linkUrl = `${CONF.otherPage.electricShop}0/0/0`;
            }
          } else {
            linkUrl = `${CONF.otherPage.electricShop}0/0/0`;
          }

          item.jumpUrl = linkUrl;

          // 电器店|红孩子母婴，有导购优先展示导购，无导购展示橱窗，无橱窗不展示
          // 1 电器店， 5 红孩子， 11影城
          // if (item.storeType == 1 || item.storeType == 5 || item.storeType == 11) {

          // 导购
          if (item.guider && item.guider.uservantUserInfos && item.guider.uservantUserInfos.length >= 4) {
            let guiders = item.guider.uservantUserInfos,
              guiderList = [];

            for (let i = 0; i < 4; i++) {
              guiderList.push({
                type: 'guide',
                img: guiders[i].guidePhoto,
                id: guiders[i].guideId,
                link: guiders[i].url,
                name: guiders[i].guideName
              });
            }
            item.windowList = guiderList;
            delete item.guider;
          } else if (item.window && item.window.length >= 4) {

            let windows = item.window,
              windowList = [];

            for (let i = 0; i < 4; i++) {
              windowList.push({
                type: item.storeType == 11 ? 'window-movie' : 'window',
                img: windows[i].newWindowImage,
                id: windows[i].windowId,
                link: windows[i].functionAddress,
                name: windows[i].windowDes
              });
            }
            item.windowList = windowList;
            delete item.window;

          } else {
            // 导购和橱窗都不展示
            item.windowList = [];
          }
          //}

          // 标签
          if (item.storeLabel && item.storeLabel.trim().length > 0) {
            item.tags = item.storeLabel.trim().split(',');
          }

          item.isActMore = false;

        });

        return data;
      },
      geoFn() {

        let _this = this;
        return new Promise((reslove, reject) => {

          if (_this.queryCondition.latitude && _this.queryCondition.longitude) {

            reslove({status: true});
          } else {
            Wap.Geo(meta => {
              _this.queryCondition.latitude = meta.location.lat || meta.location.lati;
              _this.queryCondition.longitude = meta.location.lng || meta.location.longi;
              reslove({status: true});
            });
          }
        });
      },
      prompt(storeType){
        if(storeType === '12' || storeType === '15'){
          AlertBox({
              type:'mini',
              msg:'此业态暂未开放'
            });
          return false
        }
      }
    }
  }
</script>
<style scoped>

#nstore-page {

  background: #f2f2f2;
  .nav{
    top: 0;
    position: fixed;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  .search-bar{
    top: 88px;
  }
  .loadmore {
    height: 1px;
  }

  #near-store {
    background: #fff;
    padding: 176px 20px 0 20px;

    .near-store-item {
      height: auto;
      overflow: hidden;
      border-bottom: 1px solid #f7f7f7;
      padding: 20px 0;
      position: relative;

      .ns-kli {
        position: absolute;
        top: 20px;
        right: 0;
        background: #EEEEEE;
        font-size: 22px;
        color: #999999;
        padding: 0 10px;
        border-radius: 4px;
      }
    }

    .ns-img {
      display: block;
      width: 120px;
      height: 120px;
      float: left;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }

      &.default-logo {

        @for $i from 1 to 15 {
          &.store-type-$i {
            background: url("../assets/store-type-$(i).jpg") 0 0 no-repeat;
            background-size: 100%;
          }
        }

        &.store-type-undefined {
           background: url("../assets/store-type-8.jpg") 0 0 no-repeat;
           background-size: 100%;
        }
      }
      img {
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
      }
    }
    .ns-detail {
      overflow: hidden;
      padding-left: 20px;

      h2 {
        font-family: "PingFangSC-Medium";
        font-size: 32px;
        color: #333333;
        line-height: 36px;
        /*font-weight: bold;*/
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .ns-tag {
        margin-top: 14px;

        span {
          font-family: PingFangSC-Regular;
          font-weight: normal;
          border: 1px solid #ccc;
          border-radius: 2px;
          margin-right: 10px;
          padding: 2px 12px;
          color: #333333;
          font-size: 24px;
          display: inline-block;
        }
      }

      .ns-act-container {
        margin-top: 14px;
        font-family: "PingFangSC-Regular";
        font-size: 22px;
        color: #FF9900;
        letter-spacing: 0;
        line-height: 30px;

        &.act-more {
           .ns-act-item {
             display: block;
           }
        }

        .ns-act-item {
          height: 50px;
          position: relative;
          padding-bottom: 15px;
          display: none;

          .act-arrow {
            display: none;
          }

          &:nth-of-type(1) {
            display: block;

            .act-arrow {
              display: block;
            }
          }
        }
        .act-arrow {
          transform: rotate(90deg);
          position: absolute;
          top: 2px;
          right: 0;
          background: url("../assets/arrow-icon.png") 0 0 no-repeat;
          display: block;
          width: 50px;
          height: 50px;
          background-size: 15px 28px;
        }

        .act-tag {
          background: #FF9900;
          padding: 3px 7px;
          font-size: 10px;
          color: #ffffff;
          margin-right: 10px;
          border-radius: 2px;
        }
      }
      .ns-guide {
        margin-top: 15px;
        height: auto;
        overflow: hidden;

        > div {
          float: left;
          width: 128px;
          margin-right: 19px;
          overflow: hidden;
          height: auto;
          font-family: "PingFangSC-Regular";
          text-align: center;
          font-size: 24px;
          color: #222222;
          letter-spacing: 0.52px;
          line-height: 30px;

          &:nth-last-of-type(1) {
            margin-right: 0 !important;
          }

          &.guide {
             width: 80px;
             margin-right: 82px;
            .ns-guide-pic {
              width: 80px;
              height:  80px;
              img {
                display: block;
                overflow: hidden;
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          &.window {
             width: 128px;
             margin-right: 19px;
             color: #FF6600;
            .ns-guide-pic {
              width: 128px;
              height: 128px;

              img {
                display: block;
                width: 128px;
                height: 128px;
              }
            }
          }
          &.window-movie {
             width: 128px;
             margin-right: 19px;

            .ns-guide-pic {
              width: 128px;
              height:  176px;

              img {
                display: block;
                width: 128px;
                height: 128px;
              }
            }
          }
        }

        span {
          display: block;
          padding-top: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SearchStore.vue